import './popupEditRichiestaFerie.scss';

import React, { useState, useImperativeHandle, useEffect, useRef } from "react";
import { Popup, Form } from "devextreme-react";
import { Position } from "devextreme-react/popup";
import { FormRef, Item } from "devextreme-react/form";
import { useScreenSize } from "../../utils/media-query";

import useApiConfiguration from "../../apiConfig";
import { RichiesteCausaliCDLApi, RichiesteCausaliCdlResponseDTO } from "../../data";

export type PopupEditRichiestaFerieHandle = {
    show: (id: number, editing: boolean) => void
};

type Props = {
    onChange: () => void
};

type State = {
    id: number | undefined,
    isEditing: boolean,
    visible: boolean
};

const PopupEditRichiestaFerie: React.ForwardRefRenderFunction<PopupEditRichiestaFerieHandle, Props> = (props, ref) => {
    const formRef = useRef<FormRef>(null);
    const apiConfiguration = useApiConfiguration();
    const { isLarge } = useScreenSize();

    const [state, setState] = useState<State>({ id: undefined, isEditing: false, visible: false });
    const [formData, setFormData] = useState<RichiesteCausaliCdlResponseDTO>();
    const [giornoSingolo, setGiornoSingolo] = useState<boolean>(false);
    const [daApprovare, setDaApprovare] = useState<boolean>(true);
    const [testoApprovazione, setTestoApprovazione] = useState<string>("");

    useImperativeHandle(ref, () => ({
        show(id, editing) {
            setState({ id: id, isEditing: editing, visible: true });
        }
    }));

    function hideInfo() {
        setState({ id: undefined, isEditing: false, visible: false });
    };

    useEffect(() => {
        if (state.visible && state.id) {
            var api = new RichiesteCausaliCDLApi(apiConfiguration);

            api.getRichiestaCausaleCdL({
                id: state.id
            }).then((data) => {
                if (data) {
                    setFormData({
                        ...data,
                        id: state.id
                    });

                    setGiornoSingolo(data.ore != null);
                    setDaApprovare(data.approvatoIl == null);
                    setTestoApprovazione(data.approvatoIl != null ? "" : (data.approvazione === "Approvato" ? "Approvato il" : "Rifiutato il"));
                }
            });
        }
    }, [state.id, state.isEditing, state.visible]);

    return (
        <React.Fragment>
            <Popup
                visible={state.visible}
                dragEnabled={false}
                hideOnOutsideClick
                showCloseButton showTitle
                fullScreen={false}
                title={state.isEditing ? "Modifica Richiesta Ferie" : "Dettaglio Richiesta Ferie"}
                container=".dx-viewport"
                height={"auto"}
                onHidden={hideInfo}
            >
                <Position at="center" my="center" of="" collision="fit" />

                <Form ref={formRef} formData={formData} labelMode='floating' colCount={ isLarge ? 2 : 1} id="form-edit-richiesta-ferie">
                    <Item visible={false} dataField="idRichiedente" />
                    <Item visible={false} dataField="idCausaleRichiesta" />

                    {
                        !daApprovare && (
                            <React.Fragment>
                                <Item colSpan={1} dataField='approvazione' label={{ text: "Stato Richiesta" }} editorType='dxTextBox' editorOptions={{ disabled: true }} />
                                <Item colSpan={1} dataField='approvatore' editorType='dxTextBox' editorOptions={{ disabled: true }} />
                                <Item colSpan={1} dataField='approvatoIl' editorType='dxDateBox' label={{ text: testoApprovazione }}
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        disabled: true
                                    }}
                                />

                                { isLarge && <Item colSpan={1} itemType='empty' /> }
                            </React.Fragment>
                        )
                    }

                    <Item colSpan={1} dataField='richiedente' editorType='dxTextBox' editorOptions={{ disabled: true }} />
                    <Item colSpan={1} dataField='causale' editorType='dxTextBox' editorOptions={{ disabled: true }} />

                    {
                        giornoSingolo && (
                            <React.Fragment>
                                <Item colSpan={1} dataField="daData" label={{ text: "Data" }} editorType="dxDateBox"
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        openOnFieldClick: true,
                                        disabled: !state.isEditing
                                    }}
                                />

                                <Item colSpan={1} dataField="ore" label={{ text: "Ore Richieste" }} editorType="dxNumberBox"
                                    editorOptions={{
                                        default: 0.5,
                                        min: 0.5,
                                        max: 7.5,
                                        disabled: !state.isEditing
                                    }}
                                />
                            </React.Fragment>
                        )
                    }
                    
                    {
                        !giornoSingolo && (
                            <React.Fragment>
                                <Item colSpan={1} dataField='daData' label={{ text: "Data Da" }} editorType='dxDateBox'
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        openOnFieldClick: true,
                                        disabled: !state.isEditing
                                    }}
                                />

                                <Item colSpan={1} dataField='aData' label={{ text: "Data A" }} editorType='dxDateBox'
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        openOnFieldClick: true,
                                        disabled: !state.isEditing
                                    }}
                                />
                            </React.Fragment>
                        )
                    }

                    <Item colSpan={isLarge ? 2 : 1} dataField="note" label={{ text: "Note Richiesta" }}
                        editorType="dxTextArea" cssClass="dx-textarea-custom"
                        editorOptions={{
                            maxLength: 1500,
                            autoResizeEnabled: true,
                            disabled: !state.isEditing
                        }}
                    />

                    <Item colSpan={isLarge ? 2 : 1} dataField="noteApprovatore" label={{ text: "Note Approvatore" }}
                        editorType="dxTextArea" cssClass="dx-textarea-custom"
                        editorOptions={{
                            maxLength: 1500,
                            autoResizeEnabled: true,
                            disabled: !state.isEditing
                        }}
                    />
                </Form>
            </Popup>
        </React.Fragment>
    );
};

export default React.forwardRef(PopupEditRichiestaFerie);